import { useEffect, useState } from 'react';
import {
    IconButton, Badge, Popover, List, ListItem,
    ListItemText, Typography, Box, Button, Divider,
} from '@mui/material';
import { Notifications } from '@mui/icons-material';
import useNotifStore from '../store/notifStore';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fr';
dayjs.extend(relativeTime);
dayjs.locale('fr');

export default function NotificationBell() {
    const { unread, notifications, fetch, toutLire } = useNotifStore();
    const [anchor, setAnchor] = useState(null);

    useEffect(() => { fetch(); }, [fetch]);

    return (
        <>
            <IconButton color="inherit" onClick={(e) => setAnchor(e.currentTarget)}>
                <Badge badgeContent={unread} color="error">
                    <Notifications />
                </Badge>
            </IconButton>

            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Box sx={{ width: 360 }}>
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography fontWeight={700}>Notifications</Typography>
                        {unread > 0 && (
                            <Button size="small" onClick={toutLire}>
                                Tout marquer lu
                            </Button>
                        )}
                    </Box>
                    <Divider />
                    <List dense sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {notifications.length === 0 ? (
                            <ListItem>
                                <ListItemText
                                    primary="Aucune notification"
                                    primaryTypographyProps={{ color: 'text.secondary', textAlign: 'center' }}
                                />
                            </ListItem>
                        ) : (
                            notifications.map((n) => (
                                <ListItem key={n.id} sx={{ bgcolor: n.lu ? 'transparent' : '#e3f2fd' }}>
                                    <ListItemText
                                        primary={n.titre}
                                        secondary={
                                            <>
                                                <span>{n.message}</span><br />
                                                <span style={{ fontSize: 11, color: '#999' }}>
                                                    {dayjs(n.created_at).fromNow()}
                                                </span>
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))
                        )}
                    </List>
                </Box>
            </Popover>
        </>
    );
}